<div id="teacher-calendar-availability" class="container margin-top-1">
  <mat-card>
    <div class="mat-h1 margin-top-2 margin-bottom-2 text-center text-secondary">
      {{ "calendar-title" | translate }}
    </div>

    <full-calendar [options]="calendarOptions" class="margin-top-1" #calendar>
    </full-calendar>
  </mat-card>
</div>
